import React, { useState } from 'react';
import './CertificationsTab.css';
import CertificationCompaniesSubTab from './CertificationCompaniesSubTab';
import CertificationTopicsTab from './CertificationTopicsTab';
import CertificationQuestionsTab from './CertificationQuestionsTab';
import CertificationCompletionsSubTab from './CertificationCompletionsSubTab';
import CertificationQuestionGenerationSubTab from './CertificationQuestionGenerationSubTab';

function CertificationsTab() {
  const [activeSubTab, setActiveSubTab] = useState('companies');

  return (
    <div className="certifications-tab">
      <div className="sub-tabs">
        <button
          className={`sub-tab-button ${activeSubTab === 'companies' ? 'active' : ''}`}
          onClick={() => setActiveSubTab('companies')}
        >
          Компании сертификаций
        </button>
        <button
          className={`sub-tab-button ${activeSubTab === 'topics' ? 'active' : ''}`}
          onClick={() => setActiveSubTab('topics')}
        >
          Темы сертификаций
        </button>
        <button
          className={`sub-tab-button ${activeSubTab === 'questions' ? 'active' : ''}`}
          onClick={() => setActiveSubTab('questions')}
        >
          Вопросы сертификаций
        </button>
        <button
          className={`sub-tab-button ${activeSubTab === 'generate' ? 'active' : ''}`}
          onClick={() => setActiveSubTab('generate')}
        >
          Генерация вопросов
        </button>
        <button
          className={`sub-tab-button ${activeSubTab === 'completions' ? 'active' : ''}`}
          onClick={() => setActiveSubTab('completions')}
        >
          Статистика прохождений
        </button>
      </div>
      <div className="sub-tab-content">
        {activeSubTab === 'companies' && <CertificationCompaniesSubTab />}
        {activeSubTab === 'topics' && <CertificationTopicsTab />}
        {activeSubTab === 'questions' && <CertificationQuestionsTab />}
        {activeSubTab === 'generate' && <CertificationQuestionGenerationSubTab />}
        {activeSubTab === 'completions' && <CertificationCompletionsSubTab />}
      </div>
    </div>
  );
}

export default CertificationsTab;

